import { Leaf, Scissors, Sparkles } from "lucide-react";

const benefits = [
  {
    icon: Leaf,
    title: "100% Human Hair",
    body: "Ethically sourced, tangle-free strands that hold color and last.",
  },
  {
    icon: Sparkles,
    title: "Pre-Styled & Ready",
    body: "Every wig arrives plucked, bleached and styled — wear it out of the box.",
  },
  {
    icon: Scissors,
    title: "Hand-Finished Lace",
    body: "Melt-ready HD and transparent lace, knotted to look like your scalp.",
  },
];

const WhyKays = () => {
  return (
    <section data-testid="why-kays" className="border-b border-border/60 bg-[hsl(var(--background))]">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-12">
          <div className="text-xs uppercase tracking-[0.25em] text-[#B8935F] font-medium mb-2">
            The Kay's standard
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
            Hair you'll{" "}
            <em className="italic font-medium text-[hsl(var(--primary))]">live in</em>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-10 lg:gap-16">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <div key={b.title} data-testid={`why-${i}`} className="fade-up">
                <div className="w-12 h-12 rounded-sm border border-[hsl(var(--primary))]/40 text-[hsl(var(--primary))] flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-serif text-2xl text-foreground mb-2">
                  {b.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {b.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyKays;
